import React from 'react';
import {
  Typography,
  Card,
  Button,
  Row,
  Col,
  Table,
  Empty,
  Space,
  Alert,
} from 'antd';
import { MinusOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { removeFromCart, updateQuantity, selectCartTotal } from '../store/slices/cartSlice';
import { formatPrice } from '../utils/formatters';

const { Title, Text } = Typography;

const CartPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.items);
  const cartTotal = useSelector(selectCartTotal);
  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleRemove = (productId) => {
    dispatch(removeFromCart(productId));
  };

  const handleUpdateQuantity = (productId, newQuantity) => {
    if (newQuantity > 0) {
      dispatch(updateQuantity({ productId, quantity: newQuantity }));
    }
  };

  const handleCheckout = () => {
    if (isAuthenticated) {
      navigate('/checkout');
    } else {
      navigate('/login', { state: { from: '/checkout' } });
    }
  };

  if (cartItems.length === 0) {
    return (
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '64px 20px', textAlign: 'center' }}>
        <Card style={{ borderRadius: 24, boxShadow: '0 12px 32px rgba(0,0,0,0.1)' }}>
          <Empty
            description={
              <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <Title level={4} style={{ color: '#0f172a' }}>Savat bo&apos;sh</Title>
                <Text type="secondary" style={{ color: '#475569' }}>Hozircha savatga hech narsa qo&apos;shilmagan</Text>
              </div>
            }
          >
            <Button type="primary" size="large" shape="round" onClick={() => navigate('/products')}>
              Xarid qilishni boshlash
            </Button>
          </Empty>
        </Card>
      </div>
    );
  }

  const columns = [
    {
      title: 'Mahsulot',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <div>
          <Text strong>{text}</Text>
          <div>
            <Text type="secondary">
              {formatPrice(parseFloat(record.discount_price || record.price))}
            </Text>
          </div>
        </div>
      ),
    },
    {
      title: 'Miqdor',
      key: 'quantity',
      render: (_, record) => (
        <Space>
          <Button
            size="small"
            icon={<MinusOutlined />}
            onClick={() => handleUpdateQuantity(record.id, record.quantity - 1)}
          />
          <Text>{record.quantity}</Text>
          <Button
            size="small"
            icon={<PlusOutlined />}
            onClick={() => handleUpdateQuantity(record.id, record.quantity + 1)}
          />
        </Space>
      ),
    },
    {
      title: 'Jami',
      key: 'total',
      render: (_, record) => (
        <Text strong>
          {formatPrice(parseFloat(record.discount_price || record.price) * record.quantity)}
        </Text>
      ),
    },
    {
      title: '',
      key: 'actions',
      render: (_, record) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => handleRemove(record.id)}
        />
      ),
    },
  ];

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: '24px 20px' }}>
      <Title level={2} style={{ marginBottom: 24, color: '#f8fafc', fontWeight: 800, fontFamily: 'Outfit' }}>
        Savat
      </Title>

      <Row gutter={24}>
        <Col xs={24} md={16}>
          {!isAuthenticated && (
            <div style={{ marginBottom: 24 }}>
              <Alert
                message="Eslatma"
                description={
                  <span>
                    Buyurtma berish uchun tizimga kirishingiz yoki ro&apos;yxatdan o&apos;tishingiz kerak.{' '}
                    <Button type="link" onClick={() => navigate('/login')} style={{ padding: 0 }}>
                      Kirish
                    </Button>
                  </span>
                }
                type="info"
                showIcon
              />
            </div>
          )}
          <Table
            columns={columns}
            dataSource={cartItems}
            rowKey="id"
            pagination={false}
            scroll={{ x: true }}
          />
        </Col>

        <Col xs={24} md={8}>
          <Card style={{ marginTop: { xs: 24, md: 0 } }}>
            <Title level={4} style={{ marginBottom: 24 }}>
              Jami
            </Title>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <Text>Mahsulotlar:</Text>
              <Text strong>{cartItems.length}</Text>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
              <Title level={5}>Jami summa:</Title>
              <Title level={4} style={{ margin: 0, color: '#1890ff' }}>
                {formatPrice(cartTotal)}
              </Title>
            </div>

            <Button type="primary" block size="large" onClick={handleCheckout}>
              {isAuthenticated ? 'Rasmiylashtirish' : 'Kirish va Buyurtma berish'}
            </Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CartPage;
